import config from "@/config";
import Axios from "axios";

class AuthService {
  constructor() {
    this.api = Axios.create({
      baseURL: config.URL_ENDPOINT
    });
  }

  async login(payload) {
    try {
      const response = await this.api.post('/auth', payload);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar dados de reserva:", error);
      throw error;
    }
  }

}

export default AuthService;
